module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-depositNMErrorTitle',
        errorBody: 'contractsView-depositNMErrorMessage',
        backButtonLabel: 'contractSummary-backToDeposits',
        backButtonLink: '/myprofile/deposits'
    }
}